import type { CrmAlerts } from '../../../api';

type Props = {
  alerts: CrmAlerts | null;
  intakeCount: number;
  onFocusIntake: () => void;
  onFocusMyDay: () => void;
  onOpenOrder: (orderId: number) => void;
  hapticSelection: () => void;
};

export function CrmHelmsmanBar({
  alerts,
  intakeCount,
  onFocusIntake,
  onFocusMyDay,
  onOpenOrder,
  hapticSelection,
}: Props) {
  const noTask = alerts?.orders_without_valid_task ?? 0;
  const overdue = alerts?.overdue_tasks ?? 0;
  const firstNoTaskId = alerts?.order_ids_without_task?.[0];

  if (!intakeCount && !noTask && !overdue) return null;

  const chips: Array<{ key: string; label: string; color: string; onClick: () => void }> = [];

  if (intakeCount > 0) {
    chips.push({
      key: 'intake',
      label: `входящие ${intakeCount}`,
      color: '#FC814A',
      onClick: () => {
        hapticSelection();
        onFocusIntake();
      },
    });
  }
  if (overdue > 0) {
    chips.push({
      key: 'overdue',
      label: `просрочено ${overdue}`,
      color: '#FC814A',
      onClick: () => {
        hapticSelection();
        onFocusMyDay();
      },
    });
  }
  if (noTask > 0) {
    chips.push({
      key: 'notask',
      label: `без задачи ${noTask}`,
      color: '#F6AD55',
      onClick: () => {
        hapticSelection();
        if (firstNoTaskId) onOpenOrder(firstNoTaskId);
        else onFocusMyDay();
      },
    });
  }

  return (
    <div
      className="rounded-2xl px-3 py-2.5 flex flex-wrap gap-2 items-center"
      style={{ background: 'rgba(252,129,74,0.08)', border: '1px solid rgba(252,129,74,0.28)' }}
    >
      <span className="text-[10px] font-bold uppercase tracking-wide shrink-0" style={{ color: '#FBD38D' }}>
        Штурман
      </span>
      {chips.map((c) => (
        <button
          key={c.key}
          type="button"
          onClick={c.onClick}
          className="press text-[10px] font-bold px-2.5 py-1.5 rounded-lg touch-manipulation min-h-[36px]"
          style={{ background: `${c.color}22`, color: c.color, border: `1px solid ${c.color}55` }}
        >
          {c.label}
        </button>
      ))}
    </div>
  );
}
